import React from "react";
import {wording} from "../DataForForm/Wording"
import FormBlock from "../Default/FormBlock";

function DetectionMomentBlock({
  parentCallback,
  selectedValue,
  appProOrNotpro,
}) {
  const grandPublic = wording.grand_public.quand;
  const pro = wording.pro.quand;
  const items = appProOrNotpro && appProOrNotpro === "Patient" ? grandPublic : pro;

  return (
    <FormBlock
      parentCallback={parentCallback}
      selectedValue={selectedValue}
      items={items}
    ></FormBlock>
  );
}

export default DetectionMomentBlock;
